import { styled } from '@linaria/react';
import { colors, fonts, layout, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: ${space[8]};
  padding: ${space[5]} 0;

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: ${space[6]} 0 0;
  }
`;

export const LogoImg = styled.img`
  max-height: 56px;
  max-width: 100%;
  object-fit: contain;
`;

export const NameText = styled.span`
  font-family: ${fonts.heading};
  font-size: ${fonts.size.xl};
  font-weight: ${fonts.weight.medium};
  color: ${colors.fontPrimary};
  letter-spacing: 0.02em;

  @media (min-width: ${layout.desktopBreakpoint}) {
    font-size: ${fonts.size['2xl']};
  }
`;
